import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { saveByteArray } from 'src/util/saveByteArray';

enum EntubaServiceEnum {
  downloadTradeDocument = "/download/",
}

export default class EntubaService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/entuba");
  }

  public downloadDoc = async (id: number, fileName: string) => {
    const data = await this.GET(EntubaServiceEnum.downloadTradeDocument + id, "blob");
    saveByteArray(fileName, data);
    return data;
  };
}
